import { useEffect, useState } from 'react';

import axiosInstance from "../../api/axiosInstance";

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import EntryRow from './EntryRow';
import apiBaseUrl from '../../config';

export default function EntryTable({ currentMonth, currentYear }) {
    const [entries, setEntries] = useState([]);
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        const fetchAccounts = async () => {
        try {
            console.log(apiBaseUrl);
            const response =  await axiosInstance.get('api/accounts/');
            setAccounts(response.data);
        } catch (error) {
            console.error('Erreur lors de la récupération des comptes : ', error)
        }
    };
    fetchAccounts();
    }, []);

    useEffect(() => {
        fetchEntries(currentMonth, currentYear);
    }, [currentMonth, currentYear]);

    const fetchEntries = async (month, year) => {
        try {
            const response = await axiosInstance.get('api/entries/');
            const filteredEntries = response.data.filter(item => {
                const itemDate = new Date(item.date);
                return itemDate.getMonth() === month && itemDate.getFullYear() === year;
            });
            const sortedEntries = filteredEntries.sort((a, b) => new Date(a.date) - new Date(b.date));
            setEntries(sortedEntries);
        } catch (error) {
            console.error("Il y a eu une erreur lors de la récupération des transactions.", error);
        }
    };

    const handleEntryUpdate = (updatedEntry) => {
        // Mets à jour uniquement l'entry modifiée dans l'état local
        setEntries(prevEntries =>
          prevEntries.map(entry =>
            entry.id === updatedEntry.id ? { ...entry, ...updatedEntry } : entry
          )
        );
      };

    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Date</TableCell>
                        <TableCell align="center">Intitulé</TableCell>
                        <TableCell align="right">Montant (€)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {entries.map((entry) => (
                        <EntryRow key={entry.id} entry={entry} accounts={accounts} onUpdate={handleEntryUpdate} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}